import { useState } from "react";
import Header from "../Components/Header";
import HeroSection from "./Hero";
import Footer from "../Components/Footer";
import AlertSentEmail from "./AlertSentEmail";


function TennetMeeting() {
  const [open, setOpen] = useState(false)

  return (
    <div style={{ position: 'relative' }}>
      <div style={{
        position: 'absolute',
        top: '10',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 999999,
      }}>
        <AlertSentEmail open={open} setOpen={setOpen} />
      </div>
      <main>
        <Header />
        <HeroSection setOpen={setOpen} />
      </main>
      <Footer />
    </div>
  );
}

export default TennetMeeting;